import { Component, Signal, effect } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { CardComponent } from '@app/components';
import { HumiInquiryStatus } from '@app/models/kyc-kyb/types';
import { KYCKYBHeader } from '@app/modules/payroll/components/kyc-kyb/kyc-kyb-header/kyc-kyb-header.component';
import { KYCKYBInstructions } from '@app/modules/payroll/components/kyc-kyb/kyc-kyb-instructions/kyc-kyb-instructions.component';
import { PersonaScope } from '@app/modules/payroll/components/kyc-kyb/types';
import { AuthService } from '@app/services';
import { KYCKYBService } from '@app/services/kyc-kyb/kyc-kyb.service';

/**
 * If a user somehow ends up on this page despite having completed Persona verification, we redirect back to the root page of the module
 */
const REDIRECT_ON_COMPLETE: Record<PersonaScope, string[]> = {
    KYC: ['account'],
    KYB: ['company'],
};

@Component({
    templateUrl: 'kyc-kyb.view.html',
    standalone: true,
    imports: [KYCKYBInstructions, KYCKYBHeader, CardComponent],
})
export class KYCKYBPreRedirectView {
    scope: PersonaScope;
    status: Signal<HumiInquiryStatus | undefined>;

    redirectOnComplete = effect(() => {
        if (this.status() !== undefined && this.status() !== 'not_complete') {
            // Self-serve users should be returned to the quickstart
            if (this.authService.company.selfServeQuickstart) {
                this.router.navigate(['company-onboarding']);
                return;
            }
            this.router.navigate(REDIRECT_ON_COMPLETE[this.scope]);
        }
    });

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private knowYourService: KYCKYBService,
        private authService: AuthService
    ) {
        this.scope = (this.activatedRoute.snapshot.data.scope as PersonaScope | undefined) ?? 'KYC';
        this.status =
            this.scope === 'KYC'
                ? toSignal(this.knowYourService.accountStatus)
                : toSignal(this.knowYourService.companyStatus);
    }
}
